import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsPath } from '#/modules/search/events/routing/searchGetEventsPath';
import { searchGetGroupsPath } from '#/modules/search/groups/routing/searchGetGroupsPath';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetInternshipsPath } from '#/modules/search/internships/routing/searchGetInternshipsPath';
import { searchGetJobsPath } from '#/modules/search/jobs/routing/searchGetJobsPath';
import { searchGetOrgsPath } from '#/modules/search/orgs/routing/searchGetOrgsPath';
import type { SearchFiltersByName } from '#/modules/search/types/FiltersByName/SearchFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';

type Args = {
  locale: I18nLocale;
  filtersByName: SearchFiltersByName;
  q?: string;
  radius?: RadiusParam;
  sort?: SearchSortType;
  pageIndex?: number;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | null;
};

export function searchGetPathSwitch({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
  embedSearchWidgetId,
}: Args) {
  switch (filtersByName.type) {
    case 'JOB':
      return searchGetJobsPath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
        embedSearchWidgetId,
      });

    case 'INTERNSHIP':
      return searchGetInternshipsPath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
      });

    case 'VOLOP':
      return searchGetVolopsPath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
        embedSearchWidgetId,
      });

    case 'EVENT':
      return searchGetEventsPath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
      });

    case 'ORG':
      return searchGetOrgsPath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
      });

    case 'GROUP':
      return searchGetGroupsPath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
      });
  }
}
